import { render, staticRenderFns } from "./baseOpera-digRequire.vue?vue&type=template&id=2c9b3c74&scoped=true&"
import script from "./baseOpera-digRequire.vue?vue&type=script&lang=js&"
export * from "./baseOpera-digRequire.vue?vue&type=script&lang=js&"
import style0 from "./baseOpera-digRequire.vue?vue&type=style&index=0&id=2c9b3c74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9b3c74",
  null
  
)

export default component.exports